<template>
  <div>
    
    <div v-if="!rows.length">
      <div class="webkit-animation webkit-100-440"></div>
    </div>

    <div class="iaamc-carousel" style="position: relative">
      <div id="video-carousel-example2" class="carousel slide carousel-fade" data-ride="carousel">
          <!--Indicators-->
          <ol class="carousel-indicators">
              <li data-target="#video-carousel-example2" 
                v-for="(row, idx) in rows"
                :key="idx"
                :data-slide-to="idx" :class="(idx == 0) ? 'active' : ''"></li>
          </ol>
          <!--/.Indicators-->
          <!--Slides-->
          <div class="carousel-inner" role="listbox">

              <div class="carousel-item"
                :class="(index == 0) ? 'active' : ''"
                v-for="(row, index) in rows"
                :key="index"
                :data-interval="row.duration + '000'"
                >
                <div v-if="row.mimType == 'image'" class="hm-black-light">
                    <img :src="row.file" :alt="row.title">
                    <div class="content">
                        <div class="container">
                          <p v-if="row.title" class="animate__animated animate__backInLeft"
                            v-html="row.title"
                            :style="'color:'+row.title_color+' !important;white-space:break-spaces;font-family:dubai-b !important'">
                          </p>
                          <p v-if="row.subtitle" class="auther animate__animated animate__backInLeft"
                            v-html="row.subtitle"
                            :style="'color:'+row.subtitle_color+' !important;font-family:dubai-r !important;font-weight:800'">
                          </p>
                        </div>
                    </div>
                    <div class="full-bg-img"></div>
                </div>
                <div v-else class="view hm-black-light">
                    <video class="video-full" autoplay loop>
                        <source :src="row.file" type="video/mp4" />
                    </video>
                    <div class="full-bg-img"></div>
                </div>
              </div>
              <!--slide-->
          </div>
          <!--/.Slides-->

          <a class="left carousel-control" href="#video-carousel-example2" role="button" data-slide="prev">
              <span class="icon-prev" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
          </a>
          <a class="right carousel-control" href="#video-carousel-example2" role="button" data-slide="next">
              <span class="icon-next" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
          </a>
          
      </div>
    </div>
  </div>
</template>

<style scoped>
.carousel-indicators {
  margin-bottom: 0 !important;
  bottom: 30px;
}
</style>


<script>
import { Swiper, SwiperSlide, directive, Pagination } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import axios from "axios";
export default {
  name: "Slider",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      pgLoading: true,
      rows: [],

      swiperOptions: {
        loop: false,
        speed: 700,
        autoplay: {
          delay: 5000
        },
        pagination: {
          el: '.swiper-pagination'
        },
          // pagination: '.swiper-pagination'
          // Some Swiper option/callback...
      },

    };
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.$swiper
    // }
  },
  mounted() {
    // console.log('Current Swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  },
  created() {
      //
    this.fetchSlider();
  },
  methods: {
      
    fetchSlider() {
      axios
        .get(window.baseURL + "/sliders")
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
        })
        .catch(() => {});
    },


  },
};
</script>
